export const  WORKSPACE_OWNER_ID= 18
export const BUSINESS_ANALYST_ROLE = "business analyst";
export const HISTORY = "history";
